import { useSearchParams } from 'react-router-dom';

/**
 * Keep the active tab in a URL query param so the browser back button,
 * programmatic navigation, refresh and bookmarking all restore it.
 * Use a distinct paramName for nested tab sets to avoid collisions
 * (e.g. parent 'tab', child 'historyTab').
 */
export function useTabParam(defaultTab: string, paramName = 'tab') {
	const [searchParams, setSearchParams] = useSearchParams();
	const currentTab = searchParams.get(paramName) ?? defaultTab;

	const setTab = (newTab: string) => {
		setSearchParams(
			(prev) => {
				const next = new URLSearchParams(prev);
				next.set(paramName, newTab);
				return next;
			},
			{ replace: true }
		);
	};

	return [currentTab, setTab] as const;
}
